import * as React from "react";
import { forwardRef } from "react";
const SvgSort = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 8, height: 4, viewBox: "0 0 8 4", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4 4 0 0h8Z", className: "sdb98aedd6dd901f09cba3a3e8dae0088__a" }));
const ForwardRef = forwardRef(SvgSort);
export { ForwardRef as ReactComponent };
